module.exports = __webpack_public_path__ + "static/media/veritas-screenshot-1.05e25778.png";